module.exports = __webpack_public_path__ + "static/media/IEARN-icon.02f2fed6.png";